import { ref } from 'vue'
import { defineStore } from 'pinia'

import type { Dictionary } from '@/types/utils'
import type {
    QuestionnaireAnswerInput,
    QuestionnaireQuestionChoiceInput,
} from '@/graphql/api'

export function getAnswer(
    answer: QuestionnaireAnswerInput
): string | number | QuestionnaireQuestionChoiceInput[] | File | undefined {
    return (
        answer.answer.multiChoice ||
        answer.answer.number?.number ||
        answer.answer.singleChoice?.referenceId ||
        answer.answer.text?.text ||
        answer.answer.file?.file
    )
}

export type QuestionnaireStoreAnswers = Dictionary<
    Dictionary<{
        answer: QuestionnaireAnswerInput
        stepIndex: number
        stepTitle: string
    }>
>

export type QuestionnaireStore = {
    answers: QuestionnaireStoreAnswers
}

export const useQuestionnaireStore = defineStore('questionnaire', () => {
    const answers = ref<QuestionnaireStoreAnswers>({})
    const steps = ref<Record<string, Record<string, boolean>>>({})

    const setAnswer = (
        answer: QuestionnaireAnswerInput,
        stepIndex: number,
        stepTitle: string,
        questionnaireId: string
    ) => {
        if (!answers.value[questionnaireId]) {
            answers.value[questionnaireId] = {}
        }

        answers.value[questionnaireId][answer.question.referenceId] = {
            answer,
            stepIndex,
            stepTitle,
        }
    }

    const setStep = (step: number, questionnaireId: string) => {
        if (!steps.value[questionnaireId]) {
            steps.value[questionnaireId] = {}
        }
        steps.value[questionnaireId][step] = true
    }

    const clearQuestionnaireAnswers = (questionnaireId: string) => {
        delete answers.value[questionnaireId]
        delete steps.value[questionnaireId]
    }

    return {
        answers,
        steps,
        setAnswer,
        setStep,
        clearQuestionnaireAnswers,
    }
})
